import Box from "@/common/components/Box";
import Button from "@/common/components/Button";
import { EstablishmentCompanyData } from "@/common/types/establishment/company.type";
import { useNavigate } from "react-router-dom";

interface ContractSectionProps {
  establishmentCompany?: EstablishmentCompanyData;
}

const ContractSection = ({
  establishmentCompany,
}: ContractSectionProps) => {
  const navigate = useNavigate();

  return (
    <Box className="p-4 flex items-center justify-between">
      <p className="text-lg font-bold">
        Detalhes do contrato
      </p>

      <Button
        type="button"
        variant="success"
        operationKlassToCheckPermission="Admin::Establishment::Contracts::Show"
        name="open_contract"
        onClick={() => {
          navigate(`/establishments/${establishmentCompany?.id}/contracts/${establishmentCompany?.current_contract_id}`);
        }}
        disabled={!establishmentCompany?.current_contract_id}
      >
        Ver contrato
      </Button>
    </Box>
  );
}

export default ContractSection;
